module.exports = __webpack_public_path__ + "cc94b123841022356e9d9d2e597732dd.MP3";